var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _g3, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArmPowerMainIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 479.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "armPowerMainIcon2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 286",
    transform: "translate(36 48)",
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h100v100H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "armPowerMainIcon2_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 287",
    fill: "none",
    d: "M0 0h100v100H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "armPowerMainIcon2_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 286",
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h50v50H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "armPowerMainIcon2_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 287",
    fill: "none",
    d: "M0 0h50v50H0z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u5408\\u4F53 6",
    d: "M79 389.1h5V13.9h-5l8.589-11.4 8.589 11.4h-5.524v375.2h5.523l-8.588 11.4z",
    fill: "#941894"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u7DDA 119",
    fill: "none",
    stroke: "#000",
    strokeWidth: 4,
    d: "M50 3.5v474"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u7DDA 120",
    fill: "none",
    stroke: "#000",
    strokeWidth: 4,
    d: "M30.5 2h40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u7DDA 123",
    fill: "none",
    stroke: "#000",
    strokeWidth: 4,
    d: "M30.5 477.5h40"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u7DDA 131",
    fill: "none",
    stroke: "#941894",
    strokeWidth: 3,
    strokeDasharray: "4 2",
    d: "M70.5 3h28"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u7DDA 132",
    fill: "none",
    stroke: "#941894",
    strokeWidth: 3,
    strokeDasharray: "4 2",
    d: "M51.5 53H100"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u7DDA 134",
    fill: "none",
    stroke: "#941894",
    strokeWidth: 3,
    strokeDasharray: "4 2",
    d: "M51.5 401.5H100"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-36 72.5)",
    clipPath: "url(#armPowerMainIcon2_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(36 48)",
    clipPath: "url(#armPowerMainIcon2_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 313",
    fill: "#040000"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 329",
    d: "M50.037 10.76c-13.81 0-25 10.951-25 24.462 0 8.815 3.942 17.763 11.39 21.485h27.221c7.448-3.722 11.39-12.67 11.39-21.485 0-13.51-11.191-24.462-25-24.462m0 39.742A15.761 15.761 0 1165.8 34.741 15.762 15.762 0 0150.037 50.5m0-29.746A13.985 13.985 0 1064.02 34.74a13.985 13.985 0 00-13.983-13.984"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 330",
    d: "M76.68 81.264l14.813-22.621-20.268-13.719 3.574-6 23.889 16.529a3.042 3.042 0 01.771 4.233l-.032.046L79.3 84.675 64.867 89.2a.76.76 0 01-.583-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 331",
    d: "M23.32 81.264L8.507 58.643l20.268-13.719-3.574-6L1.312 55.453a3.042 3.042 0 00-.771 4.233l.032.046L20.7 84.675l14.43 4.53a.76.76 0 00.583-1.4z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "ArmPowerIcon",
    transform: "translate(25 46.5)",
    clipPath: "url(#armPowerMainIcon2_svg__c)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "ArmPower"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 313",
    fill: "#040000",
    clipPath: "url(#armPowerMainIcon2_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 329",
    d: "M25.018 5.38a12.368 12.368 0 00-12.5 12.231c0 4.407 1.971 8.882 5.7 10.743h13.605c3.724-1.861 5.695-6.335 5.695-10.743a12.366 12.366 0 00-12.5-12.231m0 19.871a7.881 7.881 0 117.881-7.881 7.881 7.881 0 01-7.881 7.881m0-14.873a6.992 6.992 0 106.992 6.992 6.992 6.992 0 00-6.992-6.992"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 330",
    d: "M38.34 40.632l7.407-11.311-10.134-6.86 1.787-3 11.944 8.264a1.521 1.521 0 01.386 2.117l-.016.023-10.065 12.473-7.215 2.265a.38.38 0 01-.291-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 331",
    d: "M11.66 40.632l-7.406-11.31 10.134-6.86-1.787-3L.656 27.727a1.521 1.521 0 00-.386 2.117l.016.023 10.066 12.471 7.215 2.265a.38.38 0 00.292-.7z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "ArmPowerIcon",
    transform: "translate(25 397.5)",
    clipPath: "url(#armPowerMainIcon2_svg__c)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "ArmPower"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 313",
    fill: "#040000",
    clipPath: "url(#armPowerMainIcon2_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 329",
    d: "M25.018 5.38a12.368 12.368 0 00-12.5 12.231c0 4.407 1.971 8.882 5.7 10.743h13.605c3.724-1.861 5.695-6.335 5.695-10.743a12.366 12.366 0 00-12.5-12.231m0 19.871a7.881 7.881 0 117.881-7.881 7.881 7.881 0 01-7.881 7.881m0-14.873a6.992 6.992 0 106.992 6.992 6.992 6.992 0 00-6.992-6.992"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 330",
    d: "M38.34 40.632l7.407-11.311-10.134-6.86 1.787-3 11.944 8.264a1.521 1.521 0 01.386 2.117l-.016.023-10.065 12.473-7.215 2.265a.38.38 0 01-.291-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 331",
    d: "M11.66 40.632l-7.406-11.31 10.134-6.86-1.787-3L.656 27.727a1.521 1.521 0 00-.386 2.117l.016.023 10.066 12.471 7.215 2.265a.38.38 0 00.292-.7z"
  }))))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u7DDA 135",
    fill: "none",
    stroke: "#941894",
    strokeWidth: 3,
    strokeDasharray: "4 2",
    d: "M28.5 207.5v66"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u7DDA 136",
    fill: "none",
    stroke: "#941894",
    strokeWidth: 3,
    strokeDasharray: "4 2",
    d: "M71.5 207v66"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u5408\\u4F53 4",
    d: "M40.958 244.5v5.261h18.085v6.654H40.958v5.262L27.5 253.089zm18.085 0l13.457 8.589-13.457 8.589z",
    fill: "#941894"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u5408\\u4F53 5",
    d: "M56.911 41.6h5.315V13.9h6.654v27.7h5.208L65.5 53zm0-27.7L65.5 2.5l8.589 11.4z",
    fill: "#941894"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmPowerMainIcon2);
export default __webpack_public_path__ + "static/media/armPowerMainIcon2.efd2daea9c61f29e.svg";
export { ForwardRef as ReactComponent };